import {createRef} from "../createRef";

export default createRef({
    "id": "ROLES_UI_V",
    "source": "ROLES_UI_V",
    "fields": [
        {   "column": "id", },
        {   "column": "name", },
    ],
});
